import React, { useEffect, useState } from "react";

import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import AddOwner from "../../../../../modals/yourAssets/BOA/CustomSubOwnersModal";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import AddCircleOutlineSharpIcon from "@mui/icons-material/AddCircleOutlineSharp";
import {
  saveRm,
  updateRm,
} from "../../../../../services/yourAssets/goldRawMaterialServices";

import { SecondaryButton } from "../../../../../common/Buttons";
import { IconButton } from "@mui/material";
import { Box } from "@mui/system";
import {
  goldRawMaterialFieldsValidationSchema,
  addSubOwnersInitialValues,
  goldRawMaterialFields,
} from "../../../../../modals/yourAssets/BOA/helper";
import DeleteDataModal from "../../../../../modals/yourAssets/BOA/DeleteDataModal";
import toast, { Toaster } from "react-hot-toast";
import SimpleBarReact from "simplebar-react";
import "./../BOA.scss";
import ImportData from "../ImportData";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { assetStepsNames } from "../../../../../constants/constants";
import { updateAuditTrails } from "../../../../../services/auditTrails";
import ModifiedByToaster from "../../../../../common/ModifiedByToaster";
import {
  getClientIdFromLocalStorage,
  getDateFromDateStamp,
  getKeyFromText,
  getTimeFromDateStamp,
  changeUpdateFormat,
} from "../../../../../utils/Utilities";
import { useDispatch, useSelector } from "react-redux";
import FilePreviewModal from "../../../../yourAssets/BOA/FilePreviewModal";
import DeleteFileModal from "../../../../../modals/yourAssets/BOA/DeleteFileModal";
import { deleteUserMediaBOA } from "../../../../../services/yourAssets/CommonServices";
import { handleReloadFiles } from "../../../../../redux/slices/yourAssets/AssetsDocumentsSlice";
import { getFile } from "../../../../../services/yourAssets/BankBalancesServices";
const Summary = ({
  next,
  summaryValues,
  handleSetSummaryValues,
  updationFlag,
  deleteMainOwner,
  disableContinueButton,
  updates,
}) => {
  let clientId = getClientIdFromLocalStorage();
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const documentList = useSelector(
    (state) => state.assetsDocuments.documents.materials
  );
  const dispatch = useDispatch();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showSubOwnersModal, setShowSubOwnersModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [initialValues, setInitialValues] = useState(null);
  const [isMainOwner, setIsMainOwner] = useState(false);
  const [selectedSubOwner, setSelectedSubOwner] = useState({});
  const [updatedIds, setUpdatedIds] = useState([]);
  const [updatesList, setUpdatesList] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const [focusedDocument, setFocusedDocument] = useState({});
  const [fileStream, setFileStream] = useState("");
  const [fileName, setFileName] = useState("");
  const [deleteDocumentModal, setDeleteDocumentModal] = useState(false);
  const [previewDocument, setPreviewDocument] = useState(false);

  useEffect(() => {
    setBtnLoading(true);
    for (let i = 0; i < summaryValues?.length; i++) {
      const elementI = summaryValues[i];
      for (const key in elementI?.owner) {
        const element = elementI?.owner[key];
        const elementType = typeof element;
      }
      if (elementI?.subOwners?.length > 0) {
        for (let j = 0; j < elementI?.subOwners?.length; j++) {
          for (const key in elementI.owner) {
            const element = elementI.owner[key];
            const elementType = typeof element;
          }
        }
      }
    }
    setBtnLoading(false);
  }, [summaryValues]);
  const handleUpdates = async (data) => {
    await updateAuditTrails(data, id);
  };
  useEffect(() => {
    setUpdatedIds(
      updates
        .filter(
          (item) =>
            item.objectName === assetStepsNames[4] ||
            item?.objectName?.toLowerCase() ===
              "sub" + assetStepsNames[4]?.toLowerCase()
        )
        .map((item) => item?.keyValues?.ObjectId)
    );
    handleUpdates(
      updates
        .filter(
          (item) =>
            item.objectName === assetStepsNames[4] ||
            item?.objectName?.toLowerCase() ===
              "sub" + assetStepsNames[4]?.toLowerCase()
        )
        .map((item) => item?.auditTrailId)
    );
    setUpdatesList(
      updates
        .filter(
          (item) =>
            item.objectName === assetStepsNames[4] ||
            item?.objectName?.toLowerCase() ===
              "sub" + assetStepsNames[4]?.toLowerCase()
        )
        .map((item) => item)
    );
  }, []);

  const handleMainSubmit = async () => {
    setBtnLoading(true);
    let payload = summaryValues?.map((el) => {
      let owner = el?.owner;

      const obj = {
        materialCategoryId: el.id,
        materialId: el.materialId ? el.materialId : "",
        designation: owner?.designation,
        owner: owner?.name ?? "",
        ownerShipPercentage: owner?.ownership ?? 0,
        weight: +owner?.weight ?? "",
        value: owner?.value === "undefined" ? " " : owner?.value,
        subMaterials:
          owner?.subOwners?.map((item) => {
            return {
              materialId: el.materialId ? el.materialId : "",
              subMaterialId: item.subMaterialId ? item.subMaterialId : "",
              quantity: +item.quantity,
              owner: item.name,
              ownerShipPercentage: item.ownership,
              weight: +item.weight,
              value: item?.value === "undefined" ? " " : item?.value,
            };
          }) ?? [],
      };
      return obj;
    });

    let apiResult = await updateRm(payload, id);
    if (apiResult?.success) {
      next();
    } else {
      toast.error(t(getKeyFromText(apiResult?.message)));
    }
    setBtnLoading(false);
  };
  const handleAddOwner = (values) => {
    if (selectedRow?.type === "owner") {
      handleSetSummaryValues(
        summaryValues?.map((item, index) => {
          if (item.id === selectedRow.id)
            return {
              ...item,
              owner: { ...values, id: "id" + new Date().getTime() },
            };
          return { ...item };
        }) || []
      );
    } else {
      if (selectedRow.behaviour === "create") {
        handleSetSummaryValues(
          summaryValues?.map((item, index) => {
            if (item.id === selectedRow.id)
              return {
                ...item,
                owner: {
                  ...item.owner,
                  subOwners: item.owner?.subOwners
                    ? [
                        ...item.owner.subOwners,
                        { ...values, id: "id" + new Date().getTime() },
                      ]
                    : [{ ...values }],
                },
              };
            return { ...item };
          }) || []
        );
      } else {
        handleSetSummaryValues(
          summaryValues?.map((item, index) => {
            if (item.id === selectedRow.id)
              return {
                ...item,
                owner: {
                  ...item.owner,
                  subOwners: item?.owner?.subOwners?.map((subowner, index) => {
                    if (initialValues.id === subowner.id) {
                      return { ...values };
                    }
                    return subowner;
                  }),
                },
              };
            return { ...item };
          }) || []
        );
      }
    }
  };

  const handleDeleteOwner = (type, id, index) => {
    if (type === "owner") {
      handleSetSummaryValues(
        summaryValues.map((item, itemIndex) => {
          if (itemIndex === index)
            return {
              name: item.name,
              id: item.id,
            };
          return item;
        })
      );
    } else {
      handleSetSummaryValues(
        summaryValues.map((item, itemIndex) => {
          if (itemIndex === index)
            return {
              ...item,
              owner: {
                ...item.owner,
                subOwners: item.owner.subOwners.filter(
                  (subOwner) => subOwner.id !== id
                ),
              },
            };
          return item;
        })
      );
    }
  };
  const handleDelete = (typeId) => {
    if (isMainOwner) {
      deleteMainOwner(typeId);
    } else {
      let { id, index } = selectedSubOwner;
      handleDeleteOwner("subOwner", id, index);
    }
  };
  const handleSubOwnersModalOpen = () => {
    setShowSubOwnersModal(true);
  };

  const handleSubOwnersModalClose = () => {
    setShowSubOwnersModal(false);
    setSelectedRow(null);
  };
  const handleSetSelectedRow = (
    item,
    type,
    behaviour = "create",
    ownerName = ""
  ) => {
    setSelectedRow({ ...item, type, behaviour, ownerName });
  };

  const totalCount = () => {
    let count = 0;

    summaryValues.forEach((item) => {
      if (item?.owner) {
        count += item.owner?.value ? +item.owner.value : 0;
      }
    });
    return count.toLocaleString("de-DE");
  };

  const getInitialValues = () => {
    if (initialValues !== null) {
      return {
        designation: initialValues.designation,
        name: initialValues.name,
        ownership: initialValues.ownership,
        value: initialValues.value,
        weight: initialValues.weight,
      };
    }
    return addSubOwnersInitialValues;
  };

  const handleRemoveFile = (obj) => {
    setFocusedDocument(obj);
    setDeleteDocumentModal(true);
  };
  const handleClosePreviewModal = () => {
    setPreviewDocument(false);
    setFocusedDocument("");
    setFileStream("");
  };
  const handleCloseDeleteModal = () => {
    setDeleteDocumentModal(false);
  };
  const handleViewFile = async (document) => {
    const { boaUserMediaFileId, originalFilename } = document;
    setFileName(originalFilename);
    const result = await getFile({
      userId: clientId,
      boaMediaId: boaUserMediaFileId,
    });
    if (result?.payLoad) {
      setFileStream(result.payLoad);
      setPreviewDocument(true);
      setFocusedDocument(document);
    }
  };
  const handleDeleteFile = async () => {
    const { boaUserMediaFileId } = focusedDocument;
    const result = await deleteUserMediaBOA(clientId, boaUserMediaFileId);
    if (result?.success) {
      handleCloseDeleteModal();
      handleClosePreviewModal();
      dispatch(handleReloadFiles());
    }
  };
  const handleDeleteModalShow = () => setDeleteDocumentModal(true);

  return (
    <>
      <Toaster />
      {showSubOwnersModal && (
        <AddOwner
          open={showSubOwnersModal}
          handleOpen={handleSubOwnersModalOpen}
          handleClose={handleSubOwnersModalClose}
          handleDelete={handleDeleteOwner}
          handleSubmit={handleAddOwner}
          type={selectedRow && selectedRow.type}
          id={selectedRow && selectedRow.id}
          selectedRow={
            selectedRow
              ? { ...selectedRow, name: t(getKeyFromText(selectedRow.name)) }
              : null
          }
          getInitialValues={getInitialValues}
          enteries={goldRawMaterialFields(t)}
          validationSchema={goldRawMaterialFieldsValidationSchema(t)}
        />
      )}
      {showDeleteModal && (
        <DeleteDataModal
          open={showDeleteModal}
          handleClose={() => {
            setShowDeleteModal(false);
          }}
          accountTypeId={selectedRow.id}
          deleteData={handleDelete}
          user={selectedRow?.owner?.designation}
        />
      )}
      <Box className="gold-raw-material-container">
        <Box className="table-n-btns-wrapper">
          <Box
            className="upload-add-btn-wrapper"
            component="div"
            sx={{
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
            }}
          >
            <ImportData
              sectionId={5}
              documentList={documentList}
              handleRemoveFile={handleRemoveFile}
              handleViewFile={handleViewFile}
            />
          </Box>
          <TableContainer component={Paper} className="summary-table">
            <Table
              sx={{
                "th , td": { border: "none" },
              }}
              stickyHeader
              aria-label="sticky table"
            >
              <TableHead>
                <TableRow>
                  <TableCell align="left">
                    {t("common-table-heading-5")}{" "}
                  </TableCell>
                  <TableCell align="left">
                    {t("common-table-heading-11")}{" "}
                  </TableCell>
                  <TableCell align="left">
                    {t("common-table-heading-1")}
                  </TableCell>
                  <TableCell align="left">
                    {t("common-table-heading-2")}
                  </TableCell>
                  <TableCell align="left">{t("rm-table-heading-2")}</TableCell>
                  <TableCell align="left">{t("soi-heading-4")}</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {summaryValues.map((item, index) => {
                  return (
                    <>
                      <TableRow
                        sx={{
                          backgroundColor: `${
                            index % 2 === 0 ? "color.smokeWhite" : "color.white"
                          }`,
                        }}
                        className={
                          updatedIds.includes(item?.materialId)
                            ? "highlighted-table-row"
                            : ""
                        }
                      >
                        <TableCell>
                          {item?.translationKey ? t(item.translationKey) : "-"}
                        </TableCell>

                        <TableCell>
                          {item?.owner?.designation
                            ? item.owner.designation
                            : "-"}
                        </TableCell>
                        <TableCell>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            {item?.owner?.name ? (
                              <>
                                {item.owner.name}{" "}
                                {
                                  <IconButton
                                    sx={{
                                      cursor: "pointer",
                                    }}
                                    aria-label="Add"
                                    size="small"
                                    onClick={() => {
                                      setInitialValues({
                                        designation: item?.owner?.designation,
                                        name: "",
                                        ownership: "",
                                        weight: "",
                                        value: "",
                                      });
                                      handleSubOwnersModalOpen();
                                      handleSetSelectedRow(item, "subOwner");
                                    }}
                                  >
                                    <AddCircleOutlineSharpIcon />
                                  </IconButton>
                                }
                              </>
                            ) : (
                              "-"
                            )}
                          </Box>
                        </TableCell>
                        <TableCell>
                          {item?.owner?.ownership
                            ? item.owner.ownership + "%"
                            : "-"}
                        </TableCell>
                        <TableCell>
                          {item?.owner?.weight
                            ? Number(item.owner?.weight).toLocaleString(
                                "de-DE"
                              ) + " g"
                            : "-"}
                        </TableCell>
                        <TableCell>
                          {item?.owner?.value
                            ? Number(item.owner?.value).toLocaleString(
                                "de-DE"
                              ) + " €"
                            : "-"}
                        </TableCell>
                        <TableCell>
                          {item?.owner?.name ? (
                            <>
                              <IconButton
                                sx={{ cursor: "pointer" }}
                                aria-label="add"
                                size="small"
                                onClick={() => {
                                  handleSetSelectedRow(item, "owner", "edit");
                                  setInitialValues(item.owner);
                                  handleSubOwnersModalOpen();
                                }}
                              >
                                <img
                                  src="/assets/icons/edit-icon.svg"
                                  alt="edit"
                                />
                              </IconButton>
                              <IconButton
                                sx={{ cursor: "pointer" }}
                                aria-label="delete"
                                size="small"
                                onClick={() => {
                                  setIsMainOwner(true);
                                  handleSetSelectedRow(
                                    item,
                                    "owner",
                                    "",
                                    item.owner.name
                                  );
                                  setShowDeleteModal(true);
                                }}
                              >
                                <img
                                  src="/assets/icons/delete-icon.svg"
                                  alt="delete"
                                />
                              </IconButton>
                            </>
                          ) : (
                            <>
                              <IconButton
                                sx={{
                                  cursor: "pointer",
                                }}
                                aria-label="Add"
                                size="small"
                                onClick={() => {
                                  setInitialValues(null);
                                  handleSubOwnersModalOpen();
                                  handleSetSelectedRow(item, "owner", "create");
                                }}
                              >
                                <img
                                  src="/assets/icons/edit-icon.svg"
                                  alt="edit"
                                />
                              </IconButton>
                              <IconButton
                                sx={{ cursor: "pointer" }}
                                aria-label="delete"
                                size="small"
                                onClick={() => {
                                  setIsMainOwner(true);
                                  handleSetSelectedRow(item, "owner", "", "");
                                  setShowDeleteModal(true);
                                }}
                              >
                                <img
                                  src="/assets/icons/delete-icon.svg"
                                  alt="delete"
                                />
                              </IconButton>
                            </>
                          )}
                        </TableCell>
                      </TableRow>
                      {item?.owner?.subOwners?.length > 0 &&
                        item.owner.subOwners.map((owner) => {
                          return (
                            <TableRow
                              key={owner?.id}
                              sx={{
                                backgroundColor: `${
                                  index % 2 === 0
                                    ? "color.smokeWhite"
                                    : "color.white"
                                }`,
                              }}
                              className={
                                updatedIds.includes(owner?.id)
                                  ? "highlighted-table-row"
                                  : ""
                              }
                            >
                              <TableCell />
                              <TableCell></TableCell>
                              <TableCell>{owner.name}</TableCell>
                              <TableCell>{owner.ownership + "g"}</TableCell>
                              <TableCell>{owner.weight}</TableCell>
                              <TableCell>
                                {Number(owner.value).toLocaleString("de-DE") +
                                  " €"}
                              </TableCell>
                              <TableCell>
                                <IconButton
                                  sx={{ cursor: "pointer" }}
                                  aria-label="add"
                                  size="small"
                                  onClick={() => {
                                    handleSetSelectedRow(
                                      item,
                                      "subOwner",
                                      "edit"
                                    );
                                    setInitialValues(owner);
                                    handleSubOwnersModalOpen();
                                  }}
                                >
                                  <img
                                    src="/assets/icons/edit-icon.svg"
                                    alt="edit"
                                  />
                                </IconButton>
                                <IconButton
                                  sx={{ cursor: "pointer" }}
                                  aria-label="delete"
                                  size="small"
                                  onClick={() => {
                                    setIsMainOwner(false);
                                    setSelectedSubOwner({
                                      id: owner.id,
                                      index: index,
                                    });
                                    handleSetSelectedRow(
                                      item,
                                      "owner",
                                      "",
                                      owner.name
                                    );
                                    setShowDeleteModal(true);
                                  }}
                                >
                                  <img
                                    src="/assets/icons/delete-icon.svg"
                                    alt="delete"
                                  />
                                </IconButton>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                    </>
                  );
                })}

                <TableRow sx={{ background: "#dfc8db" }}>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell align="right">{t("total")}</TableCell>
                  <TableCell
                    sx={{ paddingLeft: "16px !important" }}
                  >{`${totalCount()} € `}</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <SecondaryButton
            title={t("save-and-continue")}
            bgColor="color.magentaLight2"
            borderRadius="14px"
            width="200px"
            marginLeft="20px"
            border="none"
            hoverBgColor="color.magentaLight1"
            click={() => {
              handleMainSubmit();
            }}
            textTransform="initial"
            disabled={btnLoading}
          />
        </Box>
      </Box>
      {updatesList?.length > 0 && (
        <ModifiedByToaster
          title={`${t("modified-by")} ${updatesList[0]?.username}` || ""}
          subTitle={` ${changeUpdateFormat(
            updatesList[0]?.updatedTime,
            i18n.language
          )}`}
        />
      )}
      {previewDocument && (
        <FilePreviewModal
          data={fileStream}
          handleClose={handleClosePreviewModal}
          handleDelete={handleDeleteModalShow}
          fileName={fileName}
        />
      )}
      {deleteDocumentModal && (
        <DeleteFileModal
          show={deleteDocumentModal}
          document={focusedDocument}
          handleClose={handleCloseDeleteModal}
          handleDelete={handleDeleteFile}
        />
      )}
    </>
  );
};

export default Summary;
